import { gql } from '@apollo/client';

export const CREATE_AD_ANALYZER = gql`
  mutation CreateAdAnalyzer($request: CreateAdAnalyzerRequest!) {
    CreateAdAnalyzer(request: $request) {
      id
    }
  }
`;

export const CREATE_AD_ANALYZER_NOTE = gql`
  mutation CreateAdAnalyzerNote($request: CreateAdAnalyzerNoteRequest!) {
    CreateAdAnalyzerNote(request: $request) {
      id
    }
  }
`;

export const DELETE_AD_ANALYZER_NOTE = gql`
  mutation DeleteAdAnalyzerNote($id: String!) {
    DeleteAdAnalyzerNote(id: $id)
  }
`;

export const BULK_PIN_AD_ANALYZER = gql`
  mutation BulkPinAdAnalyzer($ids: [String!]!) {
    BulkPinAdAnalyzer(ids: $ids)
  }
`;

export const PIN_AD_ANALYZER = gql`
  mutation PinAdAnalyzer($id: String!) {
    PinAdAnalyzer(id: $id) {
      id
    }
  }
`;

export const UNPIN_AD_ANALYZER = gql`
  mutation UnPinAdAnalyzer($id: String!) {
    UnPinAdAnalyzer(id: $id) {
      id
    }
  }
`;

export const BULK_UNPIN_AD_ANALYZER = gql`
  mutation BulkUnPinAdAnalyzer($ids: [String!]!) {
    BulkUnPinAdAnalyzer(ids: $ids)
  }
`;
